var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.026 5.025l-3.874-.532L7.499.823a.547.547 0 00-.998 0l-1.653 3.67-3.874.532a.55.55 0 00-.312.935L3.52 8.81l-.716 4.042a.548.548 0 00.812.573L7 11.48l3.385 1.946a.548.548 0 00.812-.573l-.716-4.042 2.857-2.852a.55.55 0 00-.312-.934z",
    fill: "#fff"
  })));
}

export default SvgIconStarWhite;